import { DISPLAY_LANG } from '../../config';
import axios from '../../axios';

export const getDomainRegisterFormPageData = async () => {
    const res = await axios.get(`userspagesdata/domain_register_form_page?lang=${DISPLAY_LANG}`)
    return res.data[0];
};
